import { useState } from 'react'
import {
  DesignToken,
  Modal,
  ModalPortal,
  SpacingToken,
} from '@livechat/design-system-react-components'
import { css } from '@emotion/react'

import { usePreventScroll } from '@/utils/browser'
import mediaQueries from '@/layout/media-queries'
import ReviewForm from './ReviewForm'
import Reviews from './Reviews'
import RatingModalHeader from './Header'
import RatingModalFooter from './Footer'

const modalContentCss = css`
  height: calc(100% - 130px);
  overflow-y: scroll;
`

const modalCss = css`
  width: 90vw;
  max-height: 90vh;
  min-width: 300px !important;
  max-width: 640px !important;

  ${mediaQueries.mediumScreen()} {
    max-height: 650px;
  }

  > div {
    padding: var(${SpacingToken.Spacing5}) var(${SpacingToken.Spacing7});

    &:not(:last-child) {
      border-bottom: 1px solid var(${DesignToken.BorderBasicSecondary});
    }
  }

  .rating-modal-content {
    ${modalContentCss}
  }
`

interface Props {
  id: string
  onClose: () => void
  displayFormOnInit: boolean
  rate: number | null
}

const RatingModal = ({ id, onClose, displayFormOnInit, rate }: Props) => {
  const [isReviewFormOpen, setIsReviewFormOpen] = useState(displayFormOnInit)
  const displayReviewForm = () => setIsReviewFormOpen(true)

  usePreventScroll()

  return (
    <ModalPortal zIndex={1000}>
      <Modal
        data-test="rating-modal"
        css={modalCss}
        contentClassName="rating-modal-content"
        onClose={onClose}
        heading={
          <RatingModalHeader id={id} isReviewFormOpen={isReviewFormOpen} />
        }
        footer={
          <RatingModalFooter
            id={id}
            onClose={onClose}
            onClick={displayReviewForm}
            isReviewFormOpen={isReviewFormOpen}
          />
        }
        fullSpaceContent
      >
        {isReviewFormOpen ? (
          <ReviewForm id={id} rate={rate} onClose={onClose} />
        ) : (
          <Reviews id={id} />
        )}
      </Modal>
    </ModalPortal>
  )
}

export default RatingModal
